import {Pipe, PipeTransform} from '@angular/core';
import {AttributeItem} from 'src/app/users/_interfaces/users-admin';
import {ConfigService} from 'src/app/shared/services/multi-clients/config.service';
import {QuestionGroup} from '../interfaces/process-config.interface';

@Pipe({name: 'questionGroupAttributes'})
export class QuestionGroupAttributesPipe implements PipeTransform {
    
    private andOrQuestionGroupAttributes: boolean;
    constructor(private _configService: ConfigService) {
        this.andOrQuestionGroupAttributes = this._configService.settings.features.andOrQuestionGroupAttributes;
    }
    transform(groups: QuestionGroup[], attributes: AttributeItem[]): QuestionGroup[] {
        var groupsFiltered = groups
            ? groups.filter(
                g => !g.attributes
                    || g.attributes.length === 0
                    || (g.attributes.some(ga => attributes && attributes.some(a => a.id === ga.attributeId)) && this.andOrQuestionGroupAttributes)
                    || (g.attributes.every(ga => attributes && attributes.some(a => a.id === ga.attributeId)) && !this.andOrQuestionGroupAttributes)
            )
            : [];
        return groupsFiltered.filter(g => g.questions && g.questions.length > 0);
    }
}
